import template from './foodAndDrinks.html';
import styling from './foodAndDrinks.less';

export default angular.module('eventix.shop.foodAndDrinks',[])
    .config(function($stateProvider) {
        $stateProvider.state('eventix.shop.foodAndDrinks', {
            url: '/foodAndDrinks',
            views: {
                shop: {
                    controller: 'foodAndDrinksController as vm',
                    templateUrl: template
                }
            },
            resolve: /*@ngInject*/{
            }
        });
    })
    .directive('repaint', function($timeout) {
        return {
            restrict: 'C',
            link: function(scope, el, attrs) {
                $timeout(() => el.css({ zIndex: 4 }), 500);
            }
        };
    })
    .controller('foodAndDrinksController', function($state, $scope, shop, order, products, tickets, LaravelValidationRules, $filter,
        Rollbar, FB, $q, UIMessages, VisitorData, $analytics, OAuthTokens, MetaData, ShopAnalytics, Ticket, $rootScope, $window) {

        $rootScope.pageTitle = 'Tickets';

        /// Mkae sure to scroll to top
        $window.scrollTo(0, 0);

        var vm = this;
        vm.order = order;
        vm.ticketReservations = vm.order.reservations;
        vm.shop = shop;
        vm.tickets = tickets;
        vm.availableEvents = _.reduce(order.events, (total, event) => total + (event.availableTickets ? 1 : 0), 0);
        vm.fourStepWizard = vm.shop.event_selection === 'enabled' || (vm.availableEvents >= 5 && vm.shop.event_selection === 'auto');


        vm.init = init;
        function init(){
            document.getElementById("dropdown").classList.add('out');
            document.getElementById("dropdown").classList.remove('in');
        }
        init();

        vm.products = products;
        vm.verifyEmail = function(error, valid, suggestion) {
            if(!suggestion)
                return;
            if(!_.get(vm.order.receiver,'$errors.email'))
                _.set(vm.order.receiver, '$errors.email', []);
            vm.order.receiver.$errors.email.push($filter('translate')('common.notice.didYouMean', {suggestion: suggestion }));
        };

        vm.back = () => {
            if(!vm.fourStepWizard)
                return $state.go('eventix.shop.parkingtickets', { shopId: shop.guid });
            const eventId = _.findKey(order.tickets, tickets => {
                return _.some(tickets, { guid: order.firstReservation.ticket.guid });
            });
            return $state.go('eventix.shop.parkingtickets', { shopId: shop.guid, eventId });
        };
        vm.next = () => {
            let collapseToOpen;
            if (_.flatten(_.values(order.reservations)).length < 1)
                UIMessages.push('common.shop.order.empty');

            let invalid = order.hasInvalidReservations();
            if(!invalid)
                $state.go('eventix.shop.personalDetails',{ shopId: shop.guid });
            else {
                const ticketReservations = _.flatten(_.values(vm.order.reservations));
                const invalidReservation = _.find(ticketReservations, r => r.$invalid());
                collapseToOpen = _.find($scope.accordion.groups, group => {
                    const collapseReservation = _.get(group, '$parent.ticketReservation.reservation');
                    return collapseReservation === invalidReservation.reservation;
                });
                if(!collapseToOpen.isOpen)
                    collapseToOpen.toggleOpen();
            }
        };

        ShopAnalytics.checkoutStepOne();
        /*
        * We keep tabs on whether people understand the accordion.
        * If they have unopened tabs, goto that tab when you press "Next"
        */
        vm.hasOpened = { };
        _.forEach(vm.order.reservations, (ticketReservations, ticketGuid) => {
            if (!vm.order.showTicketReservationForm(ticketGuid))
                return;
            _.forEach(ticketReservations, reservation => {
                vm.hasOpened[reservation.reservation] = false;
            });
        });
        vm.logOpeningCollapse = function(reservationGuid) {
            vm.hasOpened[reservationGuid] = true;
        };

        vm.noOptionals = function(items) {
            let bool = 0;
            _.each(items, function(reservations, key){
                _.each(reservations, function(reservation){
                    let ticketName = (reservation.ticket.name).toUpperCase();
                    if(ticketName.indexOf("PARKING") == -1){
                        bool++;
                    }
                });
            });
            return (bool == 0);
        };

        vm.facebookLogin = function() {
            order.loginWithFacebook().catch(() => {
                UIMessages.push('common.shop.facebookError');
                return $q.resolve();
            }).then(() => {
                vm.manualEntry = true;
            });
        };
    }).name;
